import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { usePermissionsData } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/Providers/PermissionsProvider'

import { CompensationsUpsellButton } from '../CompensationsUpsellButton'
import { NavigateToCompensation } from '../NavigateToCompensation'

export const CompensationsBanner = () => {
  const {
    permissions: { canSeeCompensations },
  } = usePermissionsData()

  const action = () => {
    if (!canSeeCompensations) {
      return <CompensationsUpsellButton requestComponent="Compensations" />
    }

    return <NavigateToCompensation />
  }

  return (
    <Box data-testid="compensations-upload-banner">
      <Box justifyContent="center" alignItems="center" gap="s12">
        <Text.Normal size="200" weight="semibold" color="textPrimary">
          {i18n.t('finance.financial_workspace.compensations.upload_banner.title')}
        </Text.Normal>
        <Text.Normal size="200">
          {i18n.t('finance.financial_workspace.compensations.upload_banner.description_v2')}
        </Text.Normal>
        {action()}
      </Box>
    </Box>
  )
}
